import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Routes } from 'out-game/constants'
import { useAlert } from 'out-game/hooks'
import { Typography } from 'out-game/components'
import { ReactComponent as Lightning } from 'out-game/images/icons/lightning-icon.svg'
import { SetOpen } from './context'
import cn from 'classnames'
import ButtonRestyled from '../../components/ButtonRestyled'
import { useTranslationStrict } from 'out-game/hooks'

const Button: React.FC = () => {
    const { t } = useTranslationStrict('menu')

  const history = useHistory()
  const setOpen = React.useContext(SetOpen)
  const authenticated = useSelector((state) => state.data.authenticated)
  const subscriptions = useSelector((state) => state.data.ownedSubscriptions)
  const alertSubscriptionRequired = useAlert('publishingWithoutSubscription')

  return (
    <ButtonRestyled
      variant="grad-red"
      glowing
      className={cn('overlay-button', 'overlay-button_make-deal')}
      onClick={() => {
        if (authenticated === false) {
          history.push(Routes.AccessLogin)
          return
        }
        if (!subscriptions) {
          return
        }
        if (!subscriptions.some((subscription) => subscription.active)) {
          alertSubscriptionRequired(true)
          return
        }
        setOpen(true)
      }}
    >
      <Typography
        className="overlay-button__text"
        size={22}
        lineHeight={0}
        color="Emphasized"
      >
        {t('sell')}
      </Typography>
      <Lightning className="overlay-button__ico" />
    </ButtonRestyled>
  )
}

export default Button
